import { useAppSelector } from 'shared';

export const useCateringFormatPageState = (
    () => useAppSelector((store) => store.cateringFormatPage)
);
